import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartnershipService {
  constructor(public http: HttpClient) { }
  baseUrl = environment.baseUrl

  createPartnership(obj: any, token: any) {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken": token,
      })
    }
    return this.http.post(this.baseUrl + `createPartnership`, obj, httpOptions);
  }

  partnershipList(obj: any, token: any) {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken": token
      })
    }
    return this.http.get(this.baseUrl + `/getPartnershipList?limit=${obj.limit}&offset=${obj.offset}${obj.region_id ? '&region_id=' + obj.region_id : ""}${obj.group_id ? '&group_id=' + obj.group_id : ""}`, httpOptions);
  }

  updatePartnership(id: any, obj: any, token: any) {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken": token,
      })
    }
    return this.http.put(this.baseUrl + `updatePartnership/${id}`, obj, httpOptions);
  }

  deletePartnership(id: any, token: any) {
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken": token,
      })
    }
    return this.http.delete(this.baseUrl + `deletePartnership/${id}`, httpOptions);
  }
}
